import HTPatientNav from "../../pages/Dashboard/HTPatient/HTPatientNav";
import AddHtPatientProcedure from "../../pages/Dashboard/HTPatient/Procedure/AddHtPatientProcedure";
import HtPatientProcedureList from "../../pages/Dashboard/HTPatient/Procedure/HtPatientProcedureList";
import NewPatient from "../../pages/Dashboard/Reception/NewPatient/NewPatient";
import HtDashboard from "../../pages/Dashboard/HTPatient/Procedure/HtDashboard";

const HtPatientRoutes = {
  path: "/htPatient",
  element: <HTPatientNav />,
  children: [
    { path: "", element: <HtDashboard /> },
    { path: "/htPatient/new-patient", element: <NewPatient /> },
    { path: "/htPatient/add-ht-procedure", element: <AddHtPatientProcedure /> },
    { path: "/htPatient/view-procedure", element: <HtPatientProcedureList /> },
  ],
};

export default HtPatientRoutes;
